import { Route } from "@angular/router";

import { adminRoleGuard } from "@core/guards/admin-role.guard";

import { AdminRoutesConstants } from "./admin.routes.constants";

export const adminRoutes: Route = {
  path: `${AdminRoutesConstants.MAIN}`,
  canActivate: [adminRoleGuard],
  loadComponent: () => import("@features/admin/components/admin.component").then((m) => m.AdminComponent),
  children: [
    {
      path: AdminRoutesConstants.ORGANIZATIONS,
      loadComponent: () =>
        import("@features/admin/components/organizations/organizations.component").then((m) => m.OrganizationsComponent),
      data: { breadcrumb: "Organizations" },
      title: "Organizations"
    },
    {
      path: AdminRoutesConstants.USERS,
      loadComponent: () => import("@features/admin/components/users/users.component").then((m) => m.UsersComponent),
      data: { breadcrumb: "Users" },
      title: "Users"
    },
    {
      path: AdminRoutesConstants.PLANS,
      loadComponent: () => import("@features/admin/components/plans/plans.component").then((m) => m.PlansComponent),
      data: { breadcrumb: "Plans" },
      title: "Plans"
    },
    {
      path: AdminRoutesConstants.AI_USAGE,
      loadComponent: () => import("@features/admin/components/ai-usage/ai-usage.component").then((m) => m.AiUsageComponent),
      data: { breadcrumb: "AI Usage" },
      title: "AI Usage"
    },
    {
      path: AdminRoutesConstants.AI_MODELS,
      loadComponent: () => import("@features/admin/components/ai-models/ai-models.component").then((m) => m.AiModelsComponent),
      data: { breadcrumb: "AI Models" },
      title: "AI Models"
    }
  ]
};
